import Vue from 'vue'
import vueBeauty from 'vue-beauty'
import App from '@/App'
import router from '@/router'
import store from '@/store'
import fb from '@/firebase'

import 'vue-beauty/package/style/vue-beauty.min.css'
import '../node_modules/ag-grid/dist/styles/ag-grid.css'
import '../node_modules/ag-grid/dist/styles/theme-blue.css'
import './assets/styles.css'

Vue.config.productionTip = false

Vue.use(vueBeauty)
/* eslint-disable */
new Vue({
  el: '#app',
  router,
  store,
  beforeCreate () {
    fb.init(this)
  },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js